import axios from '../modules/AxiosInstance';
import Environment from '../modules/Environment';
import store from '../store';
import { PAYIT_TENANT_USER_ID, } from '../modules/Constants';

const BillingService = (() => {
  const service = {};
  const BASE_URL = `${Environment.getBaseURL()}`;

  const cancelScheduledPayment = (serviceOfferingId, scheduledPaymentId) => {
    const { authentication, } = store.getState().auth;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;

    return axios.delete(`${BASE_URL}/${serviceOfferingId}/scheduled/id/${scheduledPaymentId}`, {
      headers,
    });
  };

  const disableRecurringBillPayment = (serviceOfferingId, recurringBillPaymentId) => {
    const { authentication, } = store.getState().auth;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;

    return axios.delete(
      `${BASE_URL}/${serviceOfferingId}/recurring-bill-payments/id/${recurringBillPaymentId}`,
      { headers, }
    );
  };

  const linkAccounts = (serviceOfferingId, accountLinkRequest) => {
    const { authentication, } = store.getState().auth;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;

    return axios.post(`${BASE_URL}/${serviceOfferingId}/accounts/link`, accountLinkRequest, {
      headers,
    });
  };

  const unlinkAccounts = (serviceOfferingId, accountLinkRequest) => {
    const { authentication, } = store.getState().auth;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;

    return axios.post(`${BASE_URL}/${serviceOfferingId}/accounts/unlink`, accountLinkRequest, {
      headers,
    });
  };

  service.cancelScheduledPayment = cancelScheduledPayment;
  service.disableRecurringBillPayment = disableRecurringBillPayment;
  service.linkAccounts = linkAccounts;
  service.unlinkAccounts = unlinkAccounts;
  service.cancelScheduledPayment = cancelScheduledPayment;
  service.disableRecurringBillPayment = disableRecurringBillPayment;

  return service;
})();

export default BillingService;
